var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip",value:({
    title: _vm.title,
    placement: _vm.tooltipPlacement,
    container: _vm.tooltipContainer,
  }),expression:"{\n    title,\n    placement: tooltipPlacement,\n    container: tooltipContainer,\n  }"}],attrs:{"id":_vm.id,"aria-label":_vm.$attrs.ariaLabel || _vm.title,"category":_vm.category,"size":_vm.size,"icon":_vm.currentIcon,"variant":_vm.variant},on:{"click":_vm.onClick,"mouseleave":_vm.onMouseleave}})
}
var staticRenderFns = []

export { render, staticRenderFns }